module.exports = __webpack_public_path__ + "static/media/arrow-down.a1bedf29.svg";